import PanelForum from "./panelForum"

const TabForum = () => {

	return (
		<>
			<PanelForum/>
		</>
	)
}

export default TabForum